module.exports = __webpack_public_path__ + "img/JRB-02-2.c93c7b4c.jpg";